<sb-progressbar [width]="broadcastingRate" [showPercentageNumber]="false">
  <h6
    class="font-weight-bold d-flex justify-content-between">{{'lang.dashboard.broadcastingQuota' | translate}} {{broadcastingRate}}
    %</h6><h6
  class="font-weight-bold d-flex justify-content-between"> {{playerCount | sbNumberFormat}} {{'lang.globals.player' | translate}}</h6>
</sb-progressbar>

